import React, {useRef, useEffect, useState} from "react";
import { connect } from "react-redux";

import ShopCategoryList from "./shopCategoryList";
import {useShopContext} from "./shopNavItemsContext";
import {getAdditionalFeaturesOnScroll} from "../../../../api/look-api";
import MaterialSpinner from "../../../ui/materialSpinner";
import {setAllowMainLoading} from "../../../../actions/serverFunctions";


const ShopCategoryPage = (props) => {

  const {allowMainLoading, setAllowMainLoading, visualizersLoadedLength} = props;
  const {shopContextState} = useShopContext();
  const {shopFeatureGroup} = shopContextState;
  const [showLoader, setShowLoader] = useState(false);

  const scrollElement = useRef();

  useEffect(() => {
    let isMounted = true;
    const checkReceivedFeatures = async () => {

      if (!shopFeatureGroup) {
        if (!allowMainLoading) {
          setAllowMainLoading(true); // we will update featureGroup once again when the tool is fully loaded
        }
        return // no need to do anything if the feature group is not found
      }

      if (shopFeatureGroup && !shopFeatureGroup.allFeaturesReceived) {
        setShowLoader(true);
        await getAdditionalFeaturesOnScroll(shopFeatureGroup);
        if (isMounted) {
          setShowLoader(false);
        }
      }
    }
    checkReceivedFeatures();
    return () => {
      isMounted = false;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shopFeatureGroup, visualizersLoadedLength]);

  if (!shopFeatureGroup && visualizersLoadedLength) { // show it only when we loaded the tool
    return <h3>FeatureGroup not found. Please check opened URL</h3>
  }

  // let featureGroup = forFeature ? forFeature.getParent() : layout.getFeatureGroupByPartId(lookActiveCategory);

  return (
    <div className="shop" ref={scrollElement}>
      <div className="shop-container shop-container--full-height">
        {showLoader || (!shopFeatureGroup && !visualizersLoadedLength)
          ? <MaterialSpinner/>
          : <ShopCategoryList featureGroup={shopFeatureGroup} scrollElement={scrollElement}/>}
      </div>
    </div>
  )
};

const mapStateToProps = (store) => {
  const {visualizersLoaded, allowMainLoading} = store.serverState;

  return {
    visualizersLoadedLength: visualizersLoaded.length,
    allowMainLoading,
  };
};

const mapDispatchToProps = {
  setAllowMainLoading,
};

export default connect(mapStateToProps, mapDispatchToProps)(ShopCategoryPage)
